/* eslint-disable import/prefer-default-export */
import { SET_PROFILES } from './actionTypes';

export const setProfiles = (profiles, exportType) => {
	return {
		type: SET_PROFILES,
		payload: { profiles, exportType }
	};
};
